import { __rest } from './../../../external/tslib/tslib.es6.js';
import React, { forwardRef, useState, useEffect } from 'react';
import Column from './Column.js';
import Row from './Row.js';
import { Wrapper, StyledTable, TableCell } from './styles.js';

const DATAILED_CONTENT_WIDTH = 64;
const Table = forwardRef((_a, ref) => {
    var { rows, columns, onSort, PlaceholderElement } = _a, props = __rest(_a, ["rows", "columns", "onSort", "PlaceholderElement"]);
    const [tableColumns, setTableColumns] = useState(columns);
    const [hasDetailedContent, setHasDetailedContent] = useState(false);
    useEffect(() => {
        const rowHasDatailedContent = rows.some(({ detailedContent }) => detailedContent === null || detailedContent === void 0 ? void 0 : detailedContent.content);
        if (rowHasDatailedContent) {
            const detailedContentIconColumn = {
                key: 'detailed-button',
                name: '',
                width: DATAILED_CONTENT_WIDTH,
            };
            setTableColumns([detailedContentIconColumn, ...columns]);
            setHasDetailedContent(true);
        }
        else {
            setTableColumns(columns);
        }
    }, [rows, columns]);
    return (React.createElement(Wrapper, Object.assign({}, props),
        React.createElement(StyledTable, { ref: ref },
            React.createElement(Column, { tableColumns: tableColumns, onSort: onSort }),
            React.createElement("tbody", null, !(rows === null || rows === void 0 ? void 0 : rows.length) && PlaceholderElement ? (React.createElement("tr", null,
                React.createElement(TableCell, { colSpan: tableColumns.length }, PlaceholderElement))) : (rows.map(({ key, data, detailedContent }) => (React.createElement(Row, { key: key, data: data, hasDetailedContent: hasDetailedContent, detailedContent: detailedContent, columnsLength: columns.length }))))))));
});
Table.displayName = 'TableDesktop';

export { Table as default };
